import React, { useState } from 'react';

import InlineForm from '@plone/volto/components/manage/Form/InlineForm';

import ImageGalleryView from './ImageGalleryView';
import ImageGallerySchema from './ImageGallerySchema';

import imageSVG from '@plone/volto/icons/image.svg';

import {
  Icon,
  SidebarPortal, 
} from '@plone/volto/components';


const ImageGalleryEdit = (props) => {
  const { selected, onChangeBlock, block, data, intl, openObjectBrowser, required, resetSubmitUrl } = props;
  // const [activeFilter, setActiveFilter] = useState(0);
  const editProps = {
    ...props,
    data: {
      ...props.data,
      hidden: false,
      editEnabled: true
    }
  }
  return (
    <div>
      <SidebarPortal selected={selected}>
        <InlineForm
            icon={<Icon size="24px" name={imageSVG} />}
            schema={ImageGallerySchema}
            title={ImageGallerySchema.title}
            headerActions={<button onClick={() => {}}>Action</button>}
            footer={<div></div>}
            onChangeField={(id, value) => {
              onChangeBlock(block, {
                ...data,
                [id]: value,
              });
            }}
            formData={data}
          />
          
       </SidebarPortal> 

       <ImageGalleryView {...editProps} /> 
    </div>
  );
};

export default ImageGalleryEdit;